export function calculateSEOScore(content: string, keywords: string[]): number {
  let score = 0;
  const contentLower = content.toLowerCase();
  
  // Check keyword density
  keywords.forEach(keyword => {
    const keywordLower = keyword.toLowerCase();
    const count = (contentLower.match(new RegExp(keywordLower, 'g')) || []).length;
    score += Math.min(count * 2, 10); // Cap at 10 points per keyword
  });

  // Check content length
  const wordCount = content.split(/\s+/).length;
  score += Math.min(wordCount / 100, 20); // Up to 20 points for length

  // Check for headings
  const headings = (content.match(/#{1,6}\s/g) || []).length;
  score += Math.min(headings * 5, 15); // Up to 15 points for headings

  // Normalize score to 0-100
  return Math.min(Math.round(score), 100);
}